import React from 'react';

const ResponsiveTab = ({ tabTitles, activeTab, setActiveTab, completedTabs }) => {
  return (
    <div>
      {/* Tabs for larger screens */}
      <ul className="hidden md:block space-y-5">
        {tabTitles.map((tab, index) => {
          const isAccessible =
            index === 0 || completedTabs.includes(index - 1);

          return (
            <li
              key={index}
              className={`cursor-pointer p-4 flex items-center gap-4 border rounded-lg ${
                activeTab === index
                  ? 'bg-gradient-to-r from-purple-200 via-blue-200 to-indigo-200'
                  : isAccessible
                  ? 'bg-white border-gray-300'
                  : 'bg-gray-100 border-gray-300 opacity-50 pointer-events-none'
              }`}
              onClick={() => isAccessible && setActiveTab(index)}
            >
              <div className="icon">{tab.icon}</div>
              <div>
                <div className="text-lg font-semibold">{tab.title}</div>
                <div className="text-sm text-gray-600">{tab.description}</div>
              </div>
            </li>
          );
        })}
      </ul>

      {/* Tabs for mobile screens */}
<div className="block md:hidden">
    <ul className="flex overflow-x-auto space-x-2 p-1">  {/* Reduced spacing and padding */}
        {tabTitles.map((tab, index) => {
            const isAccessible = index === 0 || completedTabs.includes(index - 1);

            return (
                <li
                    key={index}
                    className={`cursor-pointer flex-grow flex justify-center items-center p-2 text-center rounded-lg border text-xs ${  // Use flex-grow for equal distribution
                      activeTab === index
                        ? 'bg-gradient-to-r from-purple-200 via-blue-200 to-indigo-200'
                        : isAccessible
                        ? 'bg-white border-gray-300'
                        : 'bg-gray-100 border-gray-300 opacity-50 pointer-events-none'
                    }`}
                    onClick={() => isAccessible && setActiveTab(index)}
                >
                    <div className="icon mb-1 text-sm" style={{ fontSize: '5px' }}> {/* Smaller icon size */}
                        {tab.icon}
                    </div>
                    {/*<div className="font-semibold">{tab.title}</div>   Adjusted font size here if needed */}
                </li>

            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default ResponsiveTab;
